import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20cinematic%20cityscape%20at%20night%20with%20neon%20red%20and%20gold%20accents%2C%20mysterious%20atmosphere%2C%20rain%20on%20asphalt%2C%20reflections%20of%20city%20lights%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%20and%20warm%20highlights%2C%20editorial%20photography%20style&width=1800&height=900&seq=hero-bg-2024&orientation=landscape"
        alt="黑料社区 - 最新爆料聚集地"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 mb-4 max-w-3xl leading-tight">
          最新爆料，<span className="text-accent-400">第一时间</span>掌握
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mb-8 leading-relaxed">
          黑料社区汇聚最新明星黑料、娱乐圈内幕、网红翻车事件及各类独家爆料内容，
          社区成员实时分享、讨论与互动，带你站在八卦最前线。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/exclusive"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all whitespace-nowrap text-sm"
          >
            查看独家爆料
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-50/30 hover:border-background-50/60 text-background-50 rounded-full transition-all whitespace-nowrap text-sm"
          >
            了解我们
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-8 text-xs text-background-300">
          <span className="flex items-center gap-1.5">
            <span className="font-bold text-background-50 text-lg font-heading">500万+</span> 社区成员
          </span>
          <span className="w-px h-4 bg-background-50/20"></span>
          <span className="flex items-center gap-1.5">
            <span className="font-bold text-background-50 text-lg font-heading">10万+</span> 爆料文章
          </span>
          <span className="w-px h-4 bg-background-50/20"></span>
          <span className="flex items-center gap-1.5">
            <span className="font-bold text-background-50 text-lg font-heading">80万+</span> 日活用户
          </span>
        </div>
      </div>
    </section>
  );
}